import { createFileRoute } from '@tanstack/react-router'
import { guardJeridSchoolAdminOnly } from '../../lib/auth/routeGuards'
import DirectorManagement from '@/components/jeridSchoolAdminPage/DirectorManagement'

export const Route = createFileRoute('/jerid_school_admin/directors')({
  beforeLoad: guardJeridSchoolAdminOnly,
  component: RouteComponent,
})

function RouteComponent() {
  return <DirectorManagement />
}
